import Vue from 'vue'
import Router from 'vue-router'
//import Home from '../layout/Home.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes:[
        {
            path: '/',
            name: 'home',
            component: () => import('../layout/Home'),
            meta:{
                title:'站点概况'
            }
        },
        {
            path: '/Login',
            name: 'Login',
            component: () => import(/**/'../layout/Login'),
            meta:{
                title:'用户登录'
            }
        },
        {
            path: '/bogus',
            name: 'bogus',
            component: () => import(/**/'../layout/bogus'),
            meta:{
                title:'借款/报销单'
            }
        },
        {
            path: '/bogus_op',
            name: 'bogus_op',
            component: () => import(/**/'../layout/bogus_op'),
            meta:{
                title:'添加/修改 借款/报销单'
            }
        },
        {
            path: '/bogus_detail',
            name: 'bogus_detail',
            component: () => import(/**/'../layout/bogus_detail'),
            meta:{
                title:'借款/报销单详情'
            }
        },
        {
            path: '/ChangePassword',
            name: 'ChangePassword',
            component: () => import(/**/'../layout/ChangePassword'),
            meta:{
                title:'修改密码'
            }
        },
    ]
})